import Component from '@ux/component';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * Columns item component.
 *
 * This represents an individual list item that should be placed into a column.
 * In terms of HTML, this is the `<li>` element.
 *
 * @class Columns
 * @public
 */
class ColumnItem extends Component {
  /**
   * Render the component.
   *
   * @returns {ReactElement} li
   * @api public
   */
  render() {
    const props = this.props;
    const className = this.classNames(props.className, {
      selected: props.isSelected
    });

    return <li className={ className }>{ this.props.children }</li>;
  }
}

/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 */
ColumnItem.propTypes = {
  isSelected: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node
};

export default ColumnItem;
